import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home,
    },
    {
        path: "/useragreement",
        name: "useragreement",
        component: () => import(/* webpackChunkName: "useragreement" */ "../views/useragreement.vue"),
    },
    {
        path: "/detail",
        name: "detail",
        component: () => import(/* webpackChunkName: "detail" */ "../views/Detail.vue"),
    },
    {
        path: "/my",
        name: "my",
        component: () => import(/* webpackChunkName: "my" */ "../views/my.vue"),
    },
    {
        path: "/goDraw",
        name: "goDraw",
        component: () => import(/* webpackChunkName: "goDraw" */ "../views/goDraw.vue"),
    },
    {
        path: "/privacy",
        name: "privacy",
        component: () => import(/* webpackChunkName: "privacy" */ "../views/privacy.vue"),
    },
    {
        path: "/productgodraw",
        name: "productgodraw",
        component: () => import(/* webpackChunkName: "productGoDraw" */ "../views/productGoDraw.vue"),
    },
    {
        path: "/square-detail",
        name: "SquareDetail",
        component: () => import("@/views/SquareDetail.vue"),
    },
];

const router = new VueRouter({
    routes,
});

export default router;
